import React, { useState } from 'react'
import {
  ImageUpload,
  ModalWrapper,
  SelectField,
  StyledButton,
  TextFields,
} from '../../../../../../components'
import { Avatar, Typography } from '@mui/material'
import './PopOver.css'
import { useDispatch, useSelector } from 'react-redux'
import { baseURL, getImageURL } from '../../../../../../shared/config'
import { setLoader, setRefreshPage } from '../../../../../../redux/globalSlice'
import axios from 'axios'
import { uploadImageToS3 } from '../../../../../../shared/config/S3Utils'
import { toast } from 'react-toastify'

export const InfoField = ({ label, value, width }) => (
  <div style={{ marginBottom: '20px' }}>
    <Typography mb={1}>{label}</Typography>
    <Typography
      width={width ? width : '285px'}
      sx={{ height: 'auto', minHeight: '47px' }}
      className="popover-field"
    >
      {value}
    </Typography>
  </div>
)

export const SchoolInfo = ({ open, handleClose, title }) => {
  const data = useSelector((state) => state.global.SchoolDInfo)
  return (
    <ModalWrapper open={open} handleClose={handleClose} title={title}>
      <div>
        {data?.school_avatar ? (
          <img src={data?.school_avatar} alt="" className="school-logo" />
        ) : (
          <Avatar
            alt={''}
            sx={{
              width: '76px',
              height: '76px',
              mt: 1,
              fontSize: '30px',
              backgroundColor: '#F2ECF9',
              color: '#492972',
            }}
          >
            {data?.school_name?.charAt(0).toUpperCase()}
          </Avatar>
        )}
        <div className="info-fields">
          <InfoField label="School" value={data?.school_name} />
          <InfoField label="Contact Number" value={data?.school_contact_number} />
        </div>
      </div>
    </ModalWrapper>
  )
}

export const UpdateSchoolInfo = ({ open, handleClose, title }) => {
  const schoolId = useSelector((state) => state.global.schoolID)
  const dispatch = useDispatch()
  const data = useSelector((state) => state.global.SchoolDInfo)
  // console.log('----data', data)

  const [image, setImage] = useState()
  const [schoolName, setSchoolName] = useState(data?.school_name || '')
  const [contact, setContact] = useState(data?.school_contact_number || '')
  const [schoolTiming, setSchoolTiming] = useState(data?.school_timing || '')
  const [schoolStaffTiming, setSchoolStaffTiming] = useState(data?.school_staff_timing || '')
  const [feeMethod, setFeeMethod] = useState(data?.school_fee_method || '')
  const [address, setAddress] = useState(data?.school_address || '')
  const [city, setCity] = useState(data?.school_city || '')
  const [pincode, setPincode] = useState(data?.school_pin_code || '')
  const [state, setState] = useState(data?.school_state || '')

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0]
    setImage(selectedFile)
  }
  const handleChange = (event) => {
    const { name, value } = event.target

    switch (name) {
      case 'schoolName':
        setSchoolName(value)
        break
      case 'contact':
        setContact(value.replace(/\D/g, '')) // Only numbers
        break
      case 'school_timing':
        setSchoolTiming(value)
        break
      case 'school_staff_timing':
        setSchoolStaffTiming(value)
        break
      case 'address':
        setAddress(value)
        break
      case 'city':
        setCity(value)
        break
      case 'state':
        setState(value)
        break
      case 'pincode':
        setPincode(value.replace(/\D/g, '')) // Only numbers for pincode
        break
      default:
        break
    }
  }

  const handleSubmit = async () => {
    dispatch(setLoader(true))
    let imageUrl = ''
    if (image) {
      imageUrl = await uploadImageToS3(image, 'school')
    }
    const submittingImage = image ? imageUrl : data?.school_avatar
    const reqBody = {
      school_id: schoolId,
      school_name: schoolName,
      school_contact_number: contact,
      school_avatar: submittingImage,
      school_staff_timing: schoolStaffTiming,
      school_timing: schoolTiming,
      school_fee_method: feeMethod,
      school_address: address,
      school_city: city,
      school_state: state,
      school_pin_code: pincode,
    }

    axios
      .patch(`${baseURL}/dashboard-school-fsm/v1/school/update`, reqBody)
      .then(() => {
        dispatch(setRefreshPage(true))
        toast.success('Record Updated!')
        handleClose()
        dispatch(setLoader(false))
      })
      .catch((error) => {
        console.error('Error updating school info:', error)
        dispatch(setLoader(false))
        toast.error('Error occurred while submitting')
      })
  }
  return (
    <ModalWrapper open={open} handleClose={handleClose} title={title}>
      <div>
        {/* School Logo Upload */}
        <ImageUpload
          selectedImage={image ? URL.createObjectURL(image) : data?.school_avatar}
          onFileChange={handleFileChange}
        />
        <div className="modal-scroll">
          <div
            style={{
              margin: 0,
            }}
            className="info-fields"
          >
            <TextFields
              name="schoolName"
              label="School Name"
              value={schoolName}
              onChange={handleChange}
              width="100%"
              required
            />
            <TextFields
              name="contact"
              label="Contact Number"
              value={contact}
              onChange={handleChange}
              width="100%"
              required
            />
          </div>

          {/* Address Fields - Added as requested */}
          <div
            style={{
              margin: 0,
            }}
            className="info-fields"
          >
            <TextFields
              name="address"
              label="Address"
              value={address}
              onChange={handleChange}
              width="100%"
              required
            />
            <TextFields
              name="city"
              label="City"
              value={city}
              onChange={handleChange}
              width="100%"
              required
            />
          </div>

          <div
            style={{
              margin: 0,
            }}
            className="info-fields"
          >
            <TextFields
              name="state"
              label="State"
              value={state}
              onChange={handleChange}
              width="100%"
              required
            />
            <TextFields
              name="pincode"
              label="Pincode"
              value={pincode}
              onChange={handleChange}
              width="100%"
              required
            />
          </div>

          <div
            style={{
              margin: 0,
            }}
            className="info-fields"
          >
            <SelectField
              options={[
                { label: 'Annually', value: 'Annually' },
                { label: 'Monthly', value: 'Monthly' },
              ]}
              name="school_fee_method"
              value={feeMethod}
              onChange={(value) => setFeeMethod(value)}
              width="100%"
              label="Fees Timeline"
              required
            />
          </div>

          <div
            style={{
              margin: 0,
            }}
            className="info-fields"
          >
            <TextFields
              name="school_staff_timing"
              label="School Staff Timing"
              value={schoolStaffTiming}
              onChange={handleChange}
              width="100%"
              required
              type="time"
            />
            <TextFields
              name="school_timing"
              label="School Timing"
              value={schoolTiming}
              onChange={handleChange}
              width="100%"
              required
              type="time"
            />
          </div>
        </div>

        <StyledButton width="120px" onClick={handleSubmit}>
          Submit
        </StyledButton>
      </div>
    </ModalWrapper>
  )
}
